import React, { useState, useEffect } from "react";
import { Main, Content } from "../../../components/Layout";
import { Col, Row } from "react-bootstrap";
import DatePicker from "../../../components/DatePicker";
import Slct from "../../../components/Slct";
import TabNotification from "../../../components/TabNotification";
import Button from "../../../components/Button";
import Pagenation from "../../../components/Pagenation";
import Loading from "../../../components/Loading";
import { Currency, IntegerNumber } from "../../../components/Input";
import getCommercial from "../../../util/getCommercial";
import { toast } from "react-toastify";
import useWrapper from "../../../hooks/useWrapper";
import useFormat from "../../../hooks/utils/useFormat";
import ModalFinancialReceipt from "../../../components/Modal/modal-financial-receipt";
import SlipsTable from "../../../components/SlipsTable";
import { listFinancial } from "../../../hooks/api/listFinancial";
import Accordion2 from "../../../components/Accordion";
import ButtonActions from "../../../components/Button/ButtonActions";
import api from "../../../services/api";

export default function Trainees() {
  const { setbreadcrumb, me, config, permissions } = useWrapper();
  const { formatDate, formatQuery } = useFormat();

  const [isLoadingEssential, setisLoadingEssential] = useState(false);
  const [isLoadingSlips, setisLoadingSlips] = useState(false);
  const [isWaitingResponse, setisWaitingResponse] = useState(false);

  useEffect(() => {
    setisWaitingResponse(isLoadingEssential || isLoadingSlips);
  }, [isLoadingEssential, isLoadingSlips]);

  const [commercials, setcommercials] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        setisLoadingEssential(true);
        const _commercials = await getCommercial(null, null, "?is_class=1&joins=institution,course");
        setcommercials(
          [{ value: null, label: "-- Todas --" }].concat(
            _commercials?.map(__commercial => ({
              ...__commercial,
              trainees: [{ value: null, label: "-- Todos --" }].concat(
                __commercial.trainees?.map(__trainee => ({
                  value: __trainee.id,
                  label: __trainee.name,
                })),
              ),
            })),
          ),
        );
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar carregar a lista de Turmas.");
      } finally {
        setisLoadingEssential(false);
        applyFilter(filter);
      }
    })();
    // applyFilter/filter are intentionally excluded: applyFilter is redefined every render and
    // reads `filter` itself, so depending on them would loop; this effect should only run once on
    // mount to load the initial commercial list and apply the initial filter.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [slips, setslips] = useState();
  const filter_init = {
    due_date: new Date(),
    date_type: "dueInterval",
    date_interval: false,
  };
  const [filter, setfilter] = useState(filter_init);

  const applyFilter = async (__filter, __setPreset) => {
    document.querySelector("#page-filter .accordion-button[aria-expanded='true']")?.click();
    try {
      setisLoadingSlips(true);
      const _filter = __filter || filter;
      if (!!__filter) {
        setfilter(__filter);
      }
      const { date_type, date_interval, date_start, date_end, ...query } = _filter;
      const _date_range =
        !!date_start || !!date_end
          ? { [date_type]: `${formatDate(date_start, 3) || "null"}|${formatDate(date_end, 3) || "null"}` }
          : null;
      const _query = formatQuery({
        ...query,
        ..._date_range,
      });
      const _slips = await listFinancial({
        me,
        config,
        query: _query,
      });
      setslips(_slips);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Problemas ao tentar carregar pagamentos.");
    } finally {
      setisLoadingSlips(false);
    }
  };

  const [filterTab, setfilterTab] = useState("today");
  const filterPreset = __preset => {
    if (!!isWaitingResponse) return false;
    setfilterTab(__preset);
    if (__preset === "all")
      applyFilter({
        date_type: "dueInterval",
      });
    if (__preset === "actives")
      applyFilter({
        date_type: "dueInterval",
        "!status": "pago,cancelado",
      });
    else if (__preset === "today")
      applyFilter({
        date_type: "dueInterval",
        due_date: new Date(),
      });
    else if (__preset === "willexpire")
      applyFilter({
        date_type: "dueInterval",
        date_interval: true,
        date_start: new Date(),
        "!status": "pago,nao-gerado,cancelado",
      });
    else if (__preset === "late")
      applyFilter({
        date_type: "dueInterval",
        date_interval: true,
        date_end: new Date(),
        "!status": "pago,nao-gerado,cancelado",
      });
    else if (__preset === "payed")
      applyFilter({
        date_type: "dueInterval",
        status: "pago",
      });
    else if (__preset === "canceled")
      applyFilter({
        date_type: "dueInterval",
        status: "cancelado",
      });
    else if (__preset === "processing")
      applyFilter({
        date_type: "dueInterval",
        status: "nao-gerado",
      });
    else if (__preset === "error")
      applyFilter({
        date_type: "dueInterval",
        status_error: 1,
      });
  };
  useEffect(() => {
    setbreadcrumb([{ label: "Contas a Receber" }]);
  }, [setbreadcrumb]);
  const [showModalFinancial, setshowModalFinancial] = useState(null);

  return (
    <>
      <Main>
        {!isLoadingEssential ? (
          <Content>
            <ModalFinancialReceipt
              show={showModalFinancial?.open}
              onHide={() => {
                setshowModalFinancial(null);
              }}
              transaction_config={showModalFinancial?.transaction_config}
              pre_load={showModalFinancial?.pre_load}
            />
            <Row>
              <Col sm={7}>
                <h2 className="mini-title">Gerenciar Recebimentos:</h2>
                <p className="small-label mb-4">
                  Boletos com vencimento em finais de semana e feriados poderão ser pagos no próximo dia útil sem multas
                  e taxas.
                </p>
              </Col>
              <Col sm={5} className="text-end">
                {permissions.commercial.reading && permissions.trainee.reading && permissions.financialGroup.create && (
                  <ButtonActions
                    disabled={!!isWaitingResponse}
                    options={[
                      {
                        label: "Negociar Financeiro (Individual)",
                        onClick: () => {
                          setshowModalFinancial({
                            open: true,
                            transaction_config: {
                              type: "receita",
                              batch: false,
                            },
                          });
                        },
                      },
                      {
                        label: "Negociar Financeiro (Em Lote)",
                        onClick: () => {
                          setshowModalFinancial({
                            open: true,
                            transaction_config: {
                              type: "receita",
                              batch: true,
                            },
                          });
                        },
                      },
                      {
                        label: "Consultar Pagamentos",
                        onClick: async () => {
                          try {
                            const { data: _response } = await api.get("paymentslips-verify", config);
                            toast.success(
                              `Foram verificados ${_response.total} boletos e tiveram ${_response.baixado} pagamentos confirmados.`,
                            );
                            // a consulta em lote dá baixa direto no banco; sem refetch a listagem
                            // segue mostrando os boletos como pendentes até o gestor dar F5
                            if (_response.baixado > 0) applyFilter();
                          } catch (__error) {
                            toast.error("Algo errado aconteceu. Tente mais tarde.");
                            console.log(__error);
                          }
                        },
                      },
                    ]}
                  />
                )}
              </Col>
            </Row>
            <Accordion2 id="page-filter">
              <Accordion2.Item eventKey={`page-filter`}>
                <Accordion2.Header>
                  <span>Filtro</span>
                  <Accordion2.Extras>
                    <span>{slips?.total} resultados</span>
                  </Accordion2.Extras>
                </Accordion2.Header>
                <Accordion2.Body>
                  <Row>
                    <Col sm={3}>
                      <span>Critério de Data</span>
                      <Slct
                        isDisabled={!!isWaitingResponse}
                        placeholder="..."
                        options={[
                          { value: "dueInterval", label: "Vencimento" },
                          { value: "createInterval", label: "Emissão" },
                        ]}
                        value={filter?.date_type}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            date_type: __ev.value,
                          });
                        }}
                      />
                    </Col>
                    <Col sm={3}>
                      <span>Período</span>
                      <Slct
                        isDisabled={!!isWaitingResponse}
                        placeholder="..."
                        options={[
                          { value: false, label: "Data Específica" },
                          { value: true, label: "Intervalo" },
                        ]}
                        value={filter?.date_interval || false}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            date_interval: __ev.value,
                            due_date: !__ev.value ? new Date() : null,
                            date_start: null,
                            date_end: null,
                          });
                        }}
                      />
                    </Col>
                    {!filter?.date_interval ? (
                      <Col sm={3}>
                        <span className="d-block">Data</span>
                        <DatePicker
                          disabled={!!isWaitingResponse}
                          selected={filter?.due_date}
                          onChange={__ev => {
                            setfilter({
                              ...filter,
                              due_date: __ev,
                            });
                          }}
                        />
                      </Col>
                    ) : (
                      <>
                        <Col sm={3}>
                          <span>Data Inicial</span>
                          <DatePicker
                            disabled={!!isWaitingResponse}
                            selected={filter?.date_start}
                            onChange={__ev => {
                              setfilter({
                                ...filter,
                                date_start: __ev,
                                ...(!filter?.date_end ? { date_end: __ev } : {}),
                              });
                            }}
                          />
                        </Col>
                        <Col sm={3}>
                          <span>Data Final</span>
                          <DatePicker
                            disabled={!!isWaitingResponse}
                            selected={filter?.date_end}
                            onChange={__ev => {
                              setfilter({
                                ...filter,
                                date_end: __ev,
                              });
                            }}
                          />
                        </Col>
                      </>
                    )}
                  </Row>
                  {permissions?.commercial?.reading && permissions?.trainee?.reading && (
                    <Row className="mt-2">
                      <Col sm={6}>
                        <span>Turma</span>
                        <Slct
                          isDisabled={!!isWaitingResponse}
                          placeholder="..."
                          options={commercials || []}
                          value={filter?.commercial_id}
                          onChange={__ev => {
                            setfilter({
                              ...filter,
                              trainee_id: null,
                              commercial_id: __ev.value,
                            });
                          }}
                        />
                      </Col>
                      <Col>
                        <span>Formando</span>
                        <Slct
                          isDisabled={!!isWaitingResponse}
                          placeholder="..."
                          options={
                            commercials?.find(__commercial => __commercial.value === filter?.commercial_id)?.trainees ||
                            []
                          }
                          value={filter?.trainee_id}
                          onChange={__ev => {
                            setfilter({
                              ...filter,
                              trainee_id: __ev.value,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row className="mt-2">
                    <Col sm={4}>
                      <span>Tipo de Pagamento</span>
                      <Slct
                        isDisabled={!!isWaitingResponse}
                        placeholder="..."
                        options={[
                          { value: null, label: "-- Todos --" },
                          { value: "avista", label: "À Vista" },
                          { value: "parcelado", label: "A Prazo / Parcelado" },
                        ]}
                        value={filter?.type_payment}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            type_payment: __ev.value,
                          });
                        }}
                      />
                    </Col>
                    <Col sm={4}>
                      <span>Método de Pagamento</span>
                      <Slct
                        isDisabled={!!isWaitingResponse}
                        placeholder="..."
                        options={[
                          { value: null, label: "-- Todos --" },
                          { value: "boleto", label: "Boleto" },
                          { value: "especie", label: "Espécie" },
                          { value: "pix", label: "PIX" },
                          { value: "cartao", label: "Cartão" },
                        ]}
                        value={filter?.method_payment}
                        onChange={__ev => {
                          setfilter({
                            ...filter,
                            method_payment: __ev.value,
                          });
                        }}
                      />
                    </Col>
                    <Col sm={2}>
                      <span>Código</span>
                      <IntegerNumber
                        disabled={!!isWaitingResponse}
                        value={filter?.document_number}
                        valueChange={__ev => {
                          setfilter({
                            ...filter,
                            document_number: __ev,
                          });
                        }}
                      />
                    </Col>
                    <Col sm={2}>
                      <span>Valor</span>
                      <Currency
                        disabled={!!isWaitingResponse}
                        value={filter?.value}
                        valueChange={__ev => {
                          setfilter({
                            ...filter,
                            value: __ev,
                          });
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col>
                      <span>Código de Barras do Boleto</span>
                      <IntegerNumber
                        disabled={!!isWaitingResponse}
                        maxLength="50"
                        value={filter?.bar_code}
                        valueChange={__ev => {
                          setfilter({
                            ...filter,
                            bar_code: __ev,
                          });
                        }}
                      />
                    </Col>
                  </Row>
                  {!isWaitingResponse && (
                    <Row className="mt-3">
                      <Col>
                        <Button
                          color="primary"
                          size="sm"
                          onClick={() => {
                            applyFilter();
                          }}
                        >
                          Aplicar Filtro
                        </Button>
                        <Button
                          color="grey"
                          size="sm"
                          onClick={() => {
                            applyFilter(filter_init);
                            setfilterTab("today");
                          }}
                        >
                          Limpar Filtro
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Accordion2.Body>
              </Accordion2.Item>
            </Accordion2>

            <Row className="mt-4">
              <Col>
                <TabNotification
                  style={{ fontSize: ".8em" }}
                  options={[
                    {
                      id: "all",
                      label: "Todos",
                      value: null,
                      show: true,
                    },
                    {
                      id: "actives",
                      label: "Todos Ativos",
                      value: null,
                      show: true,
                    },
                    {
                      id: "today",
                      label: "Hoje",
                      value: null,
                      show: true,
                    },
                    { id: "willexpire", label: "A Vencer", value: null, show: true },
                    {
                      id: "late",
                      label: "Atrasados",
                      value: null,
                      show: true,
                    },
                    { id: "payed", label: "Pagos", value: null, show: true },
                    {
                      id: "canceled",
                      label: "Cancelados",
                      value: null,
                      show: true,
                    },
                    {
                      id: "processing",
                      label: "Processando",
                      value: null,
                      show: true,
                    },
                    {
                      id: "error",
                      label: "Erros",
                      value: null,
                      show: true,
                    },
                  ]}
                  setActive={__ev => {
                    filterPreset(__ev);
                  }}
                  active={filterTab}
                  init={null}
                />
                {!isLoadingSlips ? (
                  <>
                    <SlipsTable
                      slips={slips?.data}
                      updateSlip={() => {
                        applyFilter();
                      }}
                      reload={() => {
                        applyFilter();
                      }}
                      show_trainee={true}
                      show_payment_for={true}
                      noborder_header={true}
                      paid_values={filterTab === "payed"}
                    />
                    <Pagenation
                      current={slips?.page}
                      total={slips?.lastPage}
                      pageChange={__page => {
                        applyFilter({
                          ...filter,
                          page: __page,
                        });
                      }}
                      className="mt-4"
                    />
                  </>
                ) : (
                  <Loading className="mt-2" />
                )}
              </Col>
            </Row>
          </Content>
        ) : (
          <Content>
            <Loading />
          </Content>
        )}
      </Main>
    </>
  );
}
